import '../assets/Tooltip-DQ4Plm4r.css';
import { options, VTooltip } from "floating-vue";
import { VTooltip as VTooltip2, options as options2 } from "floating-vue";
options.themes.tooltip.html = false;
options.themes.tooltip.delay = { show: 500, hide: 200 };
options.themes.tooltip.distance = 10;
options.themes.tooltip["arrow-padding"] = 3;
export {
  VTooltip2 as default,
  options2 as options
};
